import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import { GetListForDayData } from 'components/models';
import { Experts } from '../../api/ApiClient';
import { IExpertsFilters } from 'components/reduxModels';

const initialState: IState = {
    expertsForDayList: null,
    experts: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setExpertsList(state: IState, experts: IState['experts']) {
            return { ...state, experts };
        },
        clearExpertsList(state: IState) {
            return { ...state, experts: null };
        },
        setExpertsForDayList(state: IState, expertsForDayList: Experts | null): IState {
            return { ...state, expertsForDayList };
        },
        clearExpertsForDayList(state: IState): IState {
            return { ...state, expertsForDayList: null };
        },
    },
    effects: (dispatch: any) => ({
        async getExpertsForDayAsync(payload: GetListForDayData) {
            const expertsForDayList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertsForDay(
              payload.examDayId,
              payload.page,
              payload.pageSize,
              payload.sortOrder,
              payload.sortField,
            ));

            this.setExpertsForDayList(expertsForDayList);
        },
        async getExperts(payload: IExpertsFilters) {
            const experts = await apiConnector.execApi(dispatch, apiClient => apiClient.getExperts(
              payload.linkedWithCurrentCommission !== undefined ? payload.linkedWithCurrentCommission : true,
              payload.qualificationIds,
              payload.ascIds,
              payload.regionIds,
              payload.statuses,
              payload.searchField,
              payload.searchTerm,
              payload.page,
              payload.pageSize,
              payload.sortOrder,
              payload.sortField,
            ));
            if (!experts) return;
            this.setExpertsList(experts);
        },
    }),
});

interface IState {
    expertsForDayList: Experts | null;
    experts: Experts | null;
}
